import { createContext, useContext, useEffect, useState } from "react";
import { LANGS, translations } from "./translations";

const LanguageContext = createContext(null);

const lookup = (obj, path) => path.split(".").reduce((o, k) => (o ? o[k] : undefined), obj);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem("cagrinet_lang");
    return LANGS.some((l) => l.code === saved) ? saved : "tr";
  });

  useEffect(() => {
    localStorage.setItem("cagrinet_lang", lang);
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [lang]);

  const t = (path) => lookup(translations[lang], path) ?? lookup(translations.tr, path) ?? path;
  const ml = (field) => {
    if (!field) return "";
    return field[lang] || field.tr || "";
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, ml, isRtl: lang === "ar" }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
